export default "__VITE_ASSET__Ctrt8qls__"